$(() => {
    $('.dropdown-select').bind('select', function(e, val) {
        const option = $(this).find(`a[data-val=${val}]`);

        if (option) {
            $(this).find('li a').each(function() {
                $(this).removeClass('selected');
            });

            option.addClass('selected');

            $('.dropdown-select-btn .text').html(option.html());

            $(this).data('val', option.data('val'));

            $(this).trigger('changed', option);
        }
    });
});

$('.dropdown-select li a').click(function(e) {
    e.preventDefault();

    $(this).closest('.dropdown-select').trigger('select', $(this).data('val'));
});


